module.exports = __webpack_public_path__ + "static/media/Bellota-Regular.341871d5.ttf";